import React from 'react';
import {MasterLayout} from 'components/layouts';
import {MyBusinessManageOrderDetailContainer} from 'components/my-business';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import title from 'constants/TitlePages.js';

class MyBusinessManageOrderDetailPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.MyBusinessManageOrderDetailPage;
  }

  render() {
    return (
      <MasterLayout>
        <MyBusinessManageOrderDetailContainer params={this.props.match.params}/>
      </MasterLayout>
    );
  }
}

export default BusinessZone(MyBusinessManageOrderDetailPage);



// WEBPACK FOOTER //
// ./pages/my-business/MyBusinessManageOrderDetailPage.jsx